import React from "react";
import { Switch as SwitchReact } from "@headlessui/react";
import { twMerge } from "tailwind-merge";

type SwitchProps = {
  className?: string;
  value: boolean;
  setValue: (value: boolean) => void;
};

const Switch: React.FC<SwitchProps> = ({ className, value, setValue }: SwitchProps) => (
  <div className={`inline-flex shrink-0 ${className}`}>
    <SwitchReact
      checked={value}
      onChange={setValue}
      className={`relative inline-flex w-12 h-6 cursor-pointer rounded-full border-2 border-transparent transition-colors outline-none ${
        value ? "bg-brandPurple-500" : "bg-n-300 dark:bg-n-500"
      }`}
    >
            <span
              aria-hidden="true"
              className={twMerge(
                `pointer-events-none inline-block w-5 h-5 rounded-full bg-n-100 transition-all dark:bg-n-700 ${
                  value ? "translate-x-6 dark:bg-n-100" : "translate-x-0"
                }`
              )}
            />
    </SwitchReact>
  </div>
);

export default Switch;
